export default __webpack_public_path__ + "static/media/0717230a9fb7a99b62a9ddac6c1e0e941581617744806.3c8ff8fd.webp";